import { Injectable } from '@angular/core';
import { ApplicationService } from './application.service';

@Injectable({
    providedIn: 'root'
})
export class DBConstantsService {
    
    constructor(private applicationService: ApplicationService) { this.GetDBConstants(); }

    ProgressStatuses: any = {

        getProgressStatusIconByStatusName: (statusName) => {
            var progressStatusIcon = this.ProgressStatuses.StatusItemsList.filter(function (statusItem) { return statusItem.name === statusName; });

            if (progressStatusIcon.length > 0) {
                return progressStatusIcon[0].icon;
            }

            return '';
        },

        getProgressStatusNameByStatusId: (statusId) => {
            var progressStatusIcon = this.ProgressStatuses.StatusItemsList.filter(function (statusItem) { return statusItem.id === parseInt(statusId); });

            if (progressStatusIcon.length > 0) {
                return progressStatusIcon[0].name;
            }

            return '';
        },

        getProgressStatusIdByStatusName: (statusName) => {
            var progressStatusIcon = this.ProgressStatuses.StatusItemsList.filter(function (statusItem) { return statusItem.name === statusName; });

            if (progressStatusIcon.length > 0) {
                return progressStatusIcon[0].id;
            }

            return '';
        }

    };

    

    GetDBConstants() {
        this.applicationService.GetConstants().then((result) => {
            this.ProgressStatuses.StatusItemsList = result.data && result.data.activityScheduleStatuses ? result.data.activityScheduleStatuses : null;
            this.ProgressStatuses.StatusNamesConstants = {
                NotStarted: this.ProgressStatuses.getProgressStatusNameByStatusId(1),
                InProgress: this.ProgressStatuses.getProgressStatusNameByStatusId(2),
                Completed:  this.ProgressStatuses.getProgressStatusNameByStatusId(3)
            };
        });
    }
    
}
